import React from "react";
import { Route, Routes } from "react-router-dom";
import {Login} from "./Login";
import {Signup} from "./SignUp";
import {PostList} from"./PostList"
import {CreatePost} from "./CreatePost";
import {UpdatePost} from "./UpdatePost";

// userRouter.post('/register', register);
// userRouter.post('/login', login);
// userRouter.post('/auth/google', googleLogin);
// userRouter.get('/logout', auth,logoutUser);

// postRouter.get('/posts/category',getPostsByCategory); 
// postRouter.get('/posts/search',searchPostsByTitle); 

// postRouter.post('/posts', auth, createPost);
// postRouter.post('/posts/:post_id/like', auth, likePost);
// postRouter.post('/posts/:post_id/comment', auth, commentOnPost);

// postRouter.patch('/posts/:post_id', auth,updatePost);
// postRouter.delete('/posts/:post_id', auth, deletePost);


export const MainRoutes = () => {
  return (
    <Routes>      
      <Route path="/" element={< PostList/>} />;
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Signup />} />
      <Route path="/posts" element={< CreatePost/>} />
      <Route path="/update/:postId" element={<UpdatePost/>} />
      <Route path="*" element={<div>Page Not Found</div>} /> 
    </Routes>
  );
};